import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Localized, Hyperlink, Season } from '../../../objects';

@Injectable()
export class CalendarItemService {

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<CalendarItemSummary[]> {

    const p = new Promise<any[]>((resolve, reject) => {

      this.apiSvc.get("api/calendaritem/", null).subscribe(
        (data: CalendarItemSummary[]) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p; 

  }


  public getItem(Id: string): Promise<CalendarItem> {

    const p = new Promise<any>((resolve, reject) => {

      this.apiSvc.get("api/calendaritem/" + Id, null).subscribe(
        (data: CalendarItem) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p; 

  }

  public save(model: CalendarItem): Promise<CalendarItem> {
 
    console.log("SAVING CALENDAR ITEM", model);

    const p = new Promise<CalendarItem>((resolve, reject) => {

      if (model.Localized.find(s => s.Name == undefined || s.Name == "") != undefined) { 
        reject("All languages must have a name");
        return;
      }

      if (model.RecurrenceType == 0) {
        if (model.StartDate == undefined || model.StartDate == null || model.StartDate.toString() == "")  {
          reject("Non recurring Calendar Items must have a Start Date");
          return;
        }
      }

      // var includedSeasons: Season[] = [];
      // var season = model.ExcludedFromSeasons.forEach((s)=> {includedSeasons.push({Id:s.Id})});
      // model.ExcludedFromSeasons = includedSeasons;

      this.apiSvc.post("api/calendaritem/save", model).subscribe(
        (data: CalendarItem) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err); 
          reject(err);
        }
      );

    });

  return p;
  }

  public delete(id: string): Promise<void> {

    const p = new Promise<void>((resolve, reject) => {

      this.apiSvc.post("api/calendaritem/delete", {Id: id}).subscribe(
        (data: any) => {
            resolve();
        },
        (err) => {
          console.log("error", err); 
        }
      );

    });

  return p;
  }
}
 

export class CalendarItem {
  public Id: string;
  public StartDate: Date;
  public EndDate: Date; 

  public RecurrenceType: number;
  // public RecurrenceServiceId: string;
  public RecurrenceInterval: number;
  public RecurrenceEndDate: Date;
  public MaxOccurrences: number;

  public RecurrenceDayOfWeek: number;
  public RecurrenceWeekOfMonth: number;
  public RecurrenceDayOfMonth: number;
  public RecurrenceMonthOfYear: number;

  public ExcludedFromSeasons: Season[];
  public IncludedInSeasons: Season[];
 
  public Localized: Localized[];
  public Hyperlinks: Hyperlink[];

 
  public RecurrentAssignedServicesIdString: string;
  public RecurrentExcludedServicesIdString: string;
 
  public RecurrenceCalendarItemId: string;
  public RecurrenceCalendarItemOffsetInDays: number;

}

export class CalendarItemSummary {
  public Id: string;  
  public Name: string;
  public Description: string;
  public RecurringDescription: string;
}